// extracted by mini-css-extract-plugin
module.exports = {"label":"FilledInput_diet_label__G4rq7","value":"FilledInput_diet_value__36Yfi"};